import { render, staticRenderFns } from "./PGroup.vue?vue&type=template&id=2521806d&scoped=true&"
import script from "./PGroup.vue?vue&type=script&lang=ts&"
export * from "./PGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521806d",
  null
  
)

export default component.exports